import { Injectable } from '@angular/core';
import { IUserProfileInterface } from '../interfaces/user.interface';

@Injectable()
export class UserInfoHelperService {
  constructor() {}

  getCurrentUser(): IUserProfileInterface {
    const user = localStorage.getItem('currentUser');
    return JSON.parse(user);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/user-info-helper-service.ts